import { useCallback, useEffect, useState } from 'react'
import { gql, useLazyQuery } from '@apollo/client'
import { Metadata, ResultsList, SearchGraphql } from 'src/admin/core/models'
import { Workstation } from '../models'

const GET_WORK_STATIONS = gql`
  query GetWorkstations($where: WorkstationFilterInput, $skip: Int, $take: Int) {
    workstations(where: $where, skip: $skip, take: $take) {
      items {
        id
        name
        active
        agencyId
        type
        enterpriseId
        enterprise {
          id
          name
        }
        agency {
          id
          name
          active
        }
        accessList
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`

interface WorkstationData {
  workstations: {
    totalCount: number
    items: Workstation[]
  }
}

export const useWorkstations = () => {
  const [getResults, { loading, error, data }] = useLazyQuery<WorkstationData>(GET_WORK_STATIONS, {
    fetchPolicy: 'network-only',
  })

  const [results, setResults] = useState<ResultsList<Workstation, Metadata>>({
    results: [],
    metadata: {},
  })

  const getWorkstations = ({ where, take, skip }: SearchGraphql) => {
    getResults({
      variables: {
        where: { ...where },
        skip: skip ? skip : 0,
        take: take ? take : 100,
      },
    })
  }

  useEffect(() => {
    if (data?.workstations) {
      setResults({
        results: data?.workstations?.items || [],
        metadata: {
          Count: data?.workstations?.totalCount,
        },
      })
    }
  }, [loading])

  return { getWorkstations, loading, error, results }
}
